exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, ".HelloWorld{font-size:22px}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!../src/HelloWorld/index.css
 ** module id = 159
 ** module chunks = 0
 **/